module.exports = __webpack_public_path__ + "img/contact3.7e3199f3.jpg";